import React, {useCallback, useEffect, useState} from 'react'
import Cropper from 'react-easy-crop'
import {getOrientation} from 'get-orientation/browser'
import {getCroppedImg, getRotatedImage} from './canvasUtils'
import {Container, Wrapper} from "./styles";
import {Modal} from "antd";

const ORIENTATION_TO_ANGLE = {
    '3': 180,
    '6': 90,
    '8': -90,
}

export const EasyCrop = ({src, imgTitleToCrop, setCroppedImg: setRoomCroppedImg, setCroppedFile, handleCanselCrop}: any) => {
    const [imageSrc, setImageSrc] = useState(src)
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)

    useEffect(() => {
        src && setImageSrc(src)
    }, [src])

    const onCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

   async function dataUrlToFile(dataUrl: string, fileName: string): Promise<File> {

        const res: Response = await fetch(dataUrl);
        const blob: Blob = await res.blob();
        return new File([blob], fileName, { type: 'image/png' });
    }

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                imageSrc,
                croppedAreaPixels,
                rotation
            )
            setRoomCroppedImg(croppedImage)
            //@ts-ignore
            const file = await dataUrlToFile(croppedImage, imgTitleToCrop)
            setCroppedFile(file)
            setImageSrc('')
        } catch (e) {
            console.error(e)
        }
    }, [imageSrc, croppedAreaPixels, rotation])

    const onClose = useCallback(() => {
        setCroppedImage(null)
    }, [])

    const onFileChange = async (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            let imageDataUrl: any = await readFile(file)

            // apply rotation if needed
            const orientation = await getOrientation(file)
            //@ts-ignore
            const rotation: any = ORIENTATION_TO_ANGLE[orientation as any]
            if (rotation) {
                imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
            }

            setImageSrc(imageDataUrl)
        }
    }

    return (
        <Modal
            onOk={showCroppedImage}
            onCancel={handleCanselCrop}
            bodyStyle={{
                paddingTop: '40px'
            }}
            width={550}
            visible={!!src}>
        <Wrapper>
            {imageSrc ? (
                <Container>
                    <div>
                        <Cropper
                            //@ts-ignore
                            image={imageSrc}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={4 / 3}
                            onCropChange={setCrop}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                        />
                    </div>
                </Container>
            ) : (
                <></>
            )}
        </Wrapper>
        </Modal>
    )
}

function readFile(file: any) {
    return new Promise((resolve) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => resolve(reader.result), false)
        reader.readAsDataURL(file)
    })
}
